export default __webpack_public_path__ + "static/media/one.50a803f2.jpg";